import axios from "axios";

const axiosClient = axios.create({
  baseURL:
    process.env.REACT_APP_BASE_URL ||
    process.env.PUBLIC_URL ||
    "http://localhost:4000",
  withCredentials: true,
});

// ✅ Interceptor to attach token dynamically before every request
axiosClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("ezy_admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosClient;



// import axios from "axios";

// const axiosClient = axios.create({
//   baseURL:
//     process.env.REACT_APP_BASE_URL ||
//     process.env.PUBLIC_URL ||
//     "http://localhost:4000",
//   headers: {
//     Authorization: "Bearer " + sessionStorage.getItem("ezy_admin_token"),
//   },
//   withCredentials: true,
// });

// export default axiosClient;
